/* @ngInject */
export default function IndividualSubmissionPaginationController(
  _,
  $stateParams,
  $state,
  config,

  ReportsManager,
) {
  let hasAttemptedToLoadMore = false;
  _.extend(this, {
    $stateParams,

    getPrevious,
    getNext,
    pendoTagNext: config.pendo.submissionView.nextSubmission,
    pendoTagPrev: config.pendo.submissionView.previousSubmission,
  });

  function getPrevious() {
    if ($stateParams.galleryMode !== 'true') {
      return undefined;
    }

    const prevSubmission = ReportsManager.getPreviousReport();

    if (prevSubmission) {
      return $state.href('individual-submission-modal', {
        catalogId: getCatalogId(prevSubmission),
        reportId: prevSubmission.id,
      });
    }

    return null;
  }

  function getNext() {
    if ($stateParams.galleryMode !== 'true') {
      return undefined;
    }

    const nextSubmission = ReportsManager.getNextReport();

    if (nextSubmission) {
      return $state.href('individual-submission-modal', {
        catalogId: getCatalogId(nextSubmission),
        reportId: nextSubmission.id,
      });
    }
    if (!hasAttemptedToLoadMore) {
      hasAttemptedToLoadMore = true;
      ReportsManager.loadAdditionalResults();
    }

    return null;
  }

  function getCatalogId(submission) {
    return (submission.exercise && (submission.exercise.catalogId || submission.exercise.course?.catalogId)) || $stateParams.catalogId;
  }
}
